export const USER_INFO_REQUEST = 'AUTH/USER_INFO_REQUEST';
export const USER_INFO_SUCCESS = 'AUTH/USER_INFO_SUCCESS';
export const USER_INFO_FAILURE = 'AUTH/USER_INFO_FAILURE';
export const USER_INFO_UPDATE = 'AUTH/USER_INFO_UPDATE';

export const CUSTOMER_INFO_REQUEST = 'AUTH/CUSTOMER_INFO_REQUEST';
export const CUSTOMER_INFO_SUCCESS = 'AUTH/CUSTOMER_INFO_SUCCESS';
export const CUSTOMER_INFO_FAILURE = 'AUTH/CUSTOMER_INFO_FAILURE';
export const CUSTOMER_INFO_UPDATE = 'AUTH/CUSTOMER_INFO_UPDATE';
